export const keyVal = {
  accessToken: '179ynno_ua8s_a9fh',
};
